import { Page } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Page';
import { ImageAndText } from '@quno/patient-journey/src/contentful/patient-journey/blocks/ImageAndText';
import { Reviews } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Reviews';
import { Treatments } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Treatments';
import { BeforeAndAfter } from '@quno/patient-journey/src/contentful/patient-journey/blocks/BeforeAndAfter';
import { Logos } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Logos';
import { HeroAndFunnel } from '@quno/patient-journey/src/contentful/patient-journey/blocks/HeroAndFunnel';
import { Images } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Images';
import { Text } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Text';
import { Faq } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Faq';
import { Cards } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Cards';
import { Calendar } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Calendar';
import { Code } from '@quno/patient-journey/src/contentful/patient-journey/blocks/Code';
import type {
  BlockHeroFragment,
  BlockContainerFragment,
  BlockCardFragment,
  BlockCalendarBookingFragment,
  CtaFragment,
  BlockAccordionFragment,
  BlockAccordionItemFragment,
} from '@quno/patient-journey/src/contentful/generated/graphql-patient-journey';
import type { BasePageFragmentFragment } from '@quno/quno-gen';
import type { ModelName } from '@quno/onboarding/src/generator/types/Models';

export type BlockTypes =
  | BasePageFragmentFragment
  | BlockHeroFragment
  | BlockContainerFragment
  | BlockCardFragment
  | BlockCalendarBookingFragment
  | BlockAccordionFragment
  | BlockAccordionItemFragment
  | CtaFragment;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const blocksMapper: Partial<Record<ModelName, any>> = {
  ImageAndText,
  ReviewContainer: Reviews,
  TreatmentContainer: Treatments,
  BeforeAfterContainer: BeforeAndAfter,
  LogoContainer: Logos,
  HeroAndFunnel,
  ImageContainer: Images,
  TextContainer: Text,
  FaqContainer: Faq,
  CardContainer: Cards,
  Calendar,
  Page,
  CodeContainer: Code,
};
